import { FALLBACK_PRODUCTS, FALLBACK_GALLERIES, FALLBACK_ADS } from '../data';

const BASE_URL = 'https://api.dev.auxo.dk/public';

// Helper to normalize CMS items (e.g., localized slugs)
function normalizeItem(item) {
  if (!item) return item;
  
  // Normalize slug
  let slugStr = '';
  if (item.slug) {
    if (typeof item.slug === 'object') {
      slugStr = item.slug.da || item.slug.en || Object.values(item.slug)[0] || '';
    } else {
      slugStr = String(item.slug);
    }
  }
  
  return {
    ...item,
    slug: slugStr
  };
}

export async function fetchProducts() {
  try {
    const res = await fetch(`${BASE_URL}/v2/content/products?limit=100`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    if (data && data.items && data.items.length > 0) {
      return data.items.map(normalizeItem);
    }
    return FALLBACK_PRODUCTS;
  } catch (error) {
    console.warn('CMS fetchProducts failed, using fallback data:', error);
    return FALLBACK_PRODUCTS;
  }
}

export async function fetchGalleries() {
  try {
    const res = await fetch(`${BASE_URL}/v2/content/gallery`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    if (data && data.items && data.items.length > 0) {
      return data.items.map(normalizeItem);
    }
    return FALLBACK_GALLERIES;
  } catch (error) {
    console.warn('CMS fetchGalleries failed, using fallback data:', error);
    return FALLBACK_GALLERIES;
  }
}

export async function fetchPastAds() {
  try {
    const res = await fetch(`${BASE_URL}/content/past_ads`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      return data.map(normalizeItem);
    }
    return FALLBACK_ADS;
  } catch (error) {
    console.warn('CMS fetchPastAds failed, using fallback data:', error);
    return FALLBACK_ADS;
  }
}
